import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import type { IPendingReview } from '~/domain/ShiftReview';
import { usePendingReviewShiftCard } from './usePendingReviewShiftCard';

interface IProps {
  review: IPendingReview;
}

/** A Shift Pending Reviews row as the DS shift card; tapping opens the adjustments/details screen. */
export const PendingReviewShiftCard = ({ review }: IProps) => {
  const { cardData, onCardClick } = usePendingReviewShiftCard(review);

  return (
    <DentalOfficeShiftCard
      {...cardData}
      onCardClick={onCardClick}
      data-cy="pending-review-shift-card"
    />
  );
};
